import TerminalList from './TerminalList';
import icon from '../../icon/IcnListDevice';
import TerminalEdit from './TerminalEdit';

export default {
    list : TerminalList,
    edit : TerminalEdit,
    icon : icon
}